export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14242.c92e2bd9.jpg";